export default "__VITE_ASSET__DmaBOWXq__"